import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/auth";
import { Link } from "react-router-dom";

import NotFound from "../shared/404";

const DFY = () => {
  const dispatch = useDispatch();
  const access = useSelector((state) => state.auth.access);

  const subdomain_name = useSelector(state => state.auth.product.subdomain_name)

  const meta_data = useSelector(state => state.auth.product.meta_data)
  const logo = meta_data && JSON.parse(meta_data).subdomainLogo ? JSON.parse(meta_data).subdomainLogo : `${process.env.PUBLIC_URL}/newlogo.png`;

  const dfy_video = [
    {
      name: "Salon",
      video_link: "https://vidfolio.s3.amazonaws.com/FE/Videos/Salon.mp4",
      video_thumbnail:
        "https://s3-us-west-2.amazonaws.com/vidfoliosaleupgrade1/assets/img/SalonVideomarketing_mockup.png",
    },
    {
      name: "Restaurant",
      video_link: "https://vidfolio.s3.amazonaws.com/FE/Videos/Restaurant.mp4",
      video_thumbnail:
        "https://s3-us-west-2.amazonaws.com/vidfoliosaleupgrade1/assets/img/RESTAURANT_mockup.png",
    },
    {
      name: "Spa",
      video_link: "https://vidfolio.s3.amazonaws.com/FE/Videos/Spa.mp4",
      video_thumbnail:
        "https://s3-us-west-2.amazonaws.com/vidfoliosaleupgrade1/assets/img/Spa_mockup.png",
    },
    {
      name: "Chiropractor",
      video_link:
        "https://vidfolio.s3.amazonaws.com/FE/Videos/Chiropractor.mp4",
      video_thumbnail:
        "https://s3-us-west-2.amazonaws.com/vidfoliosaleupgrade1/assets/img/Chiro_mockup.png",
    },
    {
      name: "Dog Care",
      video_link: "https://vidfolio.s3.amazonaws.com/FE/Videos/Dog+Care.mp4",
      video_thumbnail:
        "https://s3-us-west-2.amazonaws.com/vidfoliosaleupgrade1/assets/img/dog%20care_mockup.png",
    },
  ];

  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: false }));
  });
  const DFYpage = () => {
    return (
      <section className="mid_wrap">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-4 pb-2">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Done-For-You
              </li>
            </ol>
          </nav>
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="bx_a">
                <div className="emptyDiv">
                  <img
                    src={logo}
                    alt="img"
                    className="mt-4"
                  />
                  <br />
                  <h4>{subdomain_name} DFY Agency Kit Importer Plugin:</h4>
                  <a
                    className="btn mt-3"
                    href="https://engageleads-launches.s3.us-west-2.amazonaws.com/Online/vidamaze_pl/importer_plugin/VidAmaze+Agency+Importer.zip"
                  >
                    Click here to download video Importer Plugin
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <h4 className="card-title">5 DFY Videos for Portfolio</h4>
            </div>
            <div className="card-body">
              <div className="row">
                {dfy_video &&
                  dfy_video.map((ele, index) => {
                    return (
                      <div className="col-sm-12">
                        <div className="row">
                          {(index + 1) % 2 === 0 && (
                            <>
                              <div className="col-sm-6">
                                <img src={ele.video_thumbnail} alt={ele.name} />
                              </div>
                              <div className="col-sm-6 d-flex align-items-center justify-content-center flex-column">
                                <h4>{ele.name}</h4>

                                <a
                                  href={ele.video_link}
                                  rel="noreferrer"
                                  className="btn mt-4"
                                  target="_blank"
                                  download
                                >
                                  Click here to download video
                                </a>
                              </div>
                            </>
                          )}

                          {(index + 1) % 2 !== 0 && (
                            <>
                              <div className="col-sm-6 d-flex align-items-center justify-content-center flex-column">
                                <h4>{ele.name}</h4>

                                <a
                                  href={ele.video_link}
                                  rel="noreferrer"
                                  className="btn mt-4"
                                  target="_blank"
                                  download
                                >
                                  Click here to download video
                                </a>
                              </div>

                              <div className="col-sm-6">
                                <img src={ele.video_thumbnail} alt={ele.name} />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>
      </section>
    );
  };
  return (
    <>
      { access.includes("5") || access.includes("4A") || access.includes("1a") ||access.includes("8A") ? (
        <DFYpage />
      ) : (
        <NotFound />
      )}
    </>
  );
};

export default DFY;
